import UsersIsolated from './UsersIsolated';
export default UsersIsolated;
